import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const getAsmEncryptKeyApi = async (SH_Code__c) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/currentDayTour/get-asm-encrypt-key`,
    method: "post",
    headers: headers,
    data: { code: SH_Code__c },
  };
  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
